import { useEffect } from 'react';
import { REDUX_APP_CLEAR_WEATHER_WARNING_TARGET } from 'redux-state/app/reducer.js';
import { useAppDispatch, useAppSelector } from 'redux-state/configure-store.js';

/** Checks if warningBannerTarget matches slug and clears target */
export const ManageUniqueWarningSlug = (slug: string) => {
  const appDispatch = useAppDispatch();
  const selectedItem = useAppSelector((s) => s.APP.weatherWarningTarget);
  const highlighted = selectedItem === slug;
  useEffect(() => {
    if (highlighted) {
      setTimeout(() => {
        appDispatch(REDUX_APP_CLEAR_WEATHER_WARNING_TARGET());
      }, 1000);
    }
  }, [highlighted, appDispatch]);
  return highlighted;
};
